// Module
var code = "<react-component name=\"BulkSuspendContacts\"></react-component>\n";
// Exports
module.exports = code;